import { useState } from "react"

const DARK   = "#0A0F1E"
const V      = "#7C3AED"
const V_SOFT = "#F3F0FF"
const V_MID  = "#EDE9FE"
const WHITE  = "#FFFFFF"
const OFF    = "#F9FAFB"
const TEXT   = "#09090B"
const MUTED  = "#6B7280"
const BORDER = "#E5E7EB"
const GREEN  = "#059669"
const GREEN_BG = "#ECFDF5"
const RED    = "#DC2626"
const RED_BG = "#FEF2F2"
const ORANGE = "#D97706"
const ORANGE_BG = "#FFFBEB"
const BLUE   = "#2563EB"
const BLUE_BG = "#EFF6FF"
const H = "'Plus Jakarta Sans', system-ui, sans-serif"
const B = "'Manrope', system-ui, sans-serif"

const DATA = {
  overview: { ingresos_mes:6149, ingresos_anterior:3890, usuarios_activos:87, usuarios_nuevos:14, costo_apis:434.09, margen:5714.91 },
  usuarios: [
    { nombre:"María González", email:"maria@lunaestudio.com", plan:"starter", estado:"active", imgs_usadas:24, imgs_total:30, costo_mes:4.20, ingresos:47, ultimo_acceso:"Hoy" },
    { nombre:"Carlos Mendoza", email:"carlos@kido.mx", plan:"growth", estado:"active", imgs_usadas:45, imgs_total:60, costo_mes:7.80, ingresos:87, ultimo_acceso:"Ayer" },
    { nombre:"Ana Rodríguez", email:"ana@origencafe.com", plan:"agency", estado:"active", imgs_usadas:98, imgs_total:120, costo_mes:14.20, ingresos:147, ultimo_acceso:"Hace 3 días" },
    { nombre:"Luis Herrera", email:"luis@herrera.com", plan:"starter", estado:"active", imgs_usadas:8, imgs_total:30, costo_mes:2.10, ingresos:47, ultimo_acceso:"Hace 8 días" },
    { nombre:"Sofia Vega", email:"sofia@vega.com", plan:"growth", estado:"paused", imgs_usadas:0, imgs_total:60, costo_mes:0, ingresos:0, ultimo_acceso:"Hace 18 días" },
  ],
  imagenes: { normales_mes:1840, pixar_mes:420, costo_normal:0.04, costo_pixar:0.08, paquetes:{ mini:{n:8,precio:9}, standard:{n:5,precio:19}, pro:{n:2,precio:39} } },
  personajes: { total:94, mes:18, packs_vencer:7, costo_unit:0.33, paquetes:{ single:{n:12,precio:9}, pack3:{n:5,precio:19}, pack5:{n:2,precio:29} } },
  ingresos: {
    subs: { starter:{n:52,precio:47}, growth:{n:24,precio:87}, agency:{n:11,precio:147} },
    packs_img: { mini:{n:8,precio:9}, standard:{n:5,precio:19}, pro:{n:2,precio:39} },
    packs_char:{ single:{n:12,precio:9}, pack3:{n:5,precio:19}, pack5:{n:2,precio:29} },
  },
  apis: [
    { nombre:"Claude API — Generación texto",    servicio:"Anthropic", cantidad:28400, unidad:"llamadas",  costo_unit:0.003, total:85.20 },
    { nombre:"Claude API — Análisis logo",        servicio:"Anthropic", cantidad:62,    unidad:"análisis",  costo_unit:0.003, total:0.19 },
    { nombre:"Claude API — Análisis producto",    servicio:"Anthropic", cantidad:340,   unidad:"análisis",  costo_unit:0.05,  total:17.00 },
    { nombre:"Claude API — Análisis personaje",   servicio:"Anthropic", cantidad:94,    unidad:"análisis",  costo_unit:0.05,  total:4.70 },
    { nombre:"DALL-E 3 — Imágenes normales",      servicio:"OpenAI",    cantidad:1840,  unidad:"imágenes",  costo_unit:0.04,  total:73.60 },
    { nombre:"DALL-E 3 — Imágenes Animado 3D ⚡",      servicio:"OpenAI",    cantidad:420,   unidad:"imágenes",  costo_unit:0.08,  total:33.60 },
    { nombre:"DALL-E 3 — Personajes Animado 3D ⚡",    servicio:"OpenAI",    cantidad:94,    unidad:"personajes", costo_unit:0.33,  total:31.02 },
    { nombre:"Supabase Pro",                      servicio:"Supabase",  cantidad:1,     unidad:"plan",       costo_unit:25.00, total:25.00 },
    { nombre:"Netlify Pro",                       servicio:"Netlify",   cantidad:1,     unidad:"plan",       costo_unit:19.00, total:19.00 },
    { nombre:"Cloudflare R2 Storage",             servicio:"Cloudflare",cantidad:18.4,  unidad:"GB",         costo_unit:0.015, total:0.28 },
    { nombre:"Resend Correos",                    servicio:"Resend",    cantidad:1,     unidad:"plan gratis", costo_unit:0,    total:0 },
    { nombre:"Stripe Fees (2.9% + $0.30)",        servicio:"Stripe",    cantidad:87,    unidad:"transacc.",  costo_unit:1.67,  total:145.29 },
  ],
  proveedores: [
    { nombre:"Supabase",   tipo:"Base de datos",     ultimo:"1 May 2025", proximo:"1 Jun 2025",  monto:25.00,   estado:"pagado" },
    { nombre:"Netlify",    tipo:"Hosting",            ultimo:"1 May 2025", proximo:"1 Jun 2025",  monto:19.00,   estado:"pagado" },
    { nombre:"Anthropic",  tipo:"Claude API",         ultimo:"Variable",   proximo:"Fin de mes",  monto:107.09,  estado:"en_curso" },
    { nombre:"OpenAI",     tipo:"DALL-E 3",           ultimo:"Variable",   proximo:"Fin de mes",  monto:138.22,  estado:"en_curso" },
    { nombre:"Cloudflare", tipo:"R2 Storage",         ultimo:"1 May 2025", proximo:"1 Jun 2025",  monto:0.28,    estado:"pagado" },
    { nombre:"Stripe",     tipo:"Procesador pagos",   ultimo:"Variable",   proximo:"Por transacc.",monto:145.29, estado:"en_curso" },
    { nombre:"Resend",     tipo:"Correos",            ultimo:"—",          proximo:"—",           monto:0,       estado:"gratuito" },
  ],
  retencion: { renovacion:94.2, churn:5.8, activos_7d:71, inactivos_14d:8, meses:["Ene","Feb","Mar","Abr","May"], usuarios:[12,28,45,67,87] },
  funciones: [
    { nombre:"Generación semanal total", usos:4820, pct:100, color:V },
    { nombre:"Modo: Estrategia de marca", usos:2140, pct:44, color:BLUE },
    { nombre:"Modo: Campaña de producto", usos:1480, pct:31, color:GREEN },
    { nombre:"Modo: Con personaje", usos:820, pct:17, color:"#9333EA" },
    { nombre:"Modo: Mi espacio", usos:380, pct:8, color:ORANGE },
    { nombre:"Estilo: Editorial", usos:890, pct:35, color:V },
    { nombre:"Estilo: Animado 3D ⚡", usos:420, pct:17, color:"#9333EA" },
    { nombre:"Imágenes de texto generadas", usos:1240, pct:100, color:GREEN },
  ],
  referidos: [
    { usuario:"Ana Rodríguez", referidos:6, convertidos:4, credito:40, ingresos:282 },
    { usuario:"María González", referidos:4, convertidos:3, credito:30, ingresos:188 },
    { usuario:"Carlos Mendoza", referidos:2, convertidos:2, credito:20, ingresos:94 },
    { usuario:"Diego Castro", referidos:1, convertidos:0, credito:0, ingresos:0 },
  ],
  demo: { visitas:2840, demos:680, compras:87, tasa_demo:23.9, tasa_compra:12.8, tasa_total:3.1 },
  upgrades: [
    { usuario:"Luis Herrera", de:"starter", a:"growth", fecha:"12 May 2025", tipo:"up" },
    { usuario:"Ana Rodríguez", de:"growth", a:"agency", fecha:"3 May 2025", tipo:"up" },
    { usuario:"Pedro López", de:"growth", a:"starter", fecha:"8 May 2025", tipo:"down" },
  ],
  sistema: [
    { nombre:"Supabase", estado:"ok", latencia:"42ms", uptime:"99.9%" },
    { nombre:"Cloudflare R2", estado:"ok", latencia:"18ms", uptime:"100%" },
    { nombre:"Claude API", estado:"ok", latencia:"890ms", uptime:"99.7%" },
    { nombre:"DALL-E 3", estado:"warning", latencia:"2100ms", uptime:"98.2%" },
    { nombre:"Stripe", estado:"ok", latencia:"120ms", uptime:"99.99%" },
    { nombre:"Resend", estado:"ok", latencia:"55ms", uptime:"99.8%" },
    { nombre:"Netlify", estado:"ok", latencia:"28ms", uptime:"100%" },
  ],
  alertas: [
    { tipo:"warning", titulo:"DALL-E 3 latencia alta", desc:"Tiempo de respuesta >2s en últimos 30 min. Monitorear.", tiempo:"Hace 45 min" },
    { tipo:"warning", titulo:"4 usuarios inactivos >14 días", desc:"Riesgo de cancelación. Considera enviarles un correo.", tiempo:"Hoy" },
    { tipo:"info", titulo:"7 packs de personajes por vencer", desc:"7 usuarios tienen packs que vencen en menos de 30 días.", tiempo:"Hoy" },
    { tipo:"info", titulo:"R2: superaste tier gratuito", desc:"18.4GB usados. Costo actual: $0.28/mes.", tiempo:"Este mes" },
  ],
  soporte: [
    { id:"T001", usuario:"María González", asunto:"Imagen no se genera", fecha:"14 May", estado:"resuelto", prioridad:"alta" },
    { id:"T002", usuario:"Luis Herrera", asunto:"No recibí correo de bienvenida", fecha:"16 May", estado:"pendiente", prioridad:"media" },
    { id:"T003", usuario:"Carlos Mendoza", asunto:"Personaje no se guarda", fecha:"17 May", estado:"en_proceso", prioridad:"alta" },
  ],
  notas_init: [
    { fecha:"18 May 2025", texto:"Lanzar campaña de referidos con los primeros 10 clientes esta semana." },
    { fecha:"15 May 2025", texto:"Revisar por qué Modo Mi espacio tiene tan poco uso — posiblemente comunicación en onboarding." },
    { fecha:"10 May 2025", texto:"DALL-E 3 tuvo 2 outages este mes. Considerar sistema de retry automático en backend." },
  ],
}

const fmt = n => "$" + Number(n).toLocaleString("es-MX",{minimumFractionDigits:2,maximumFractionDigits:2})
const fmtn = n => Number(n).toLocaleString("es-MX")
const pchg = (a,b) => b ? (((a-b)/b)*100).toFixed(1) : 0

const NAV = [
  {id:"dashboard",  icon:"📊", label:"Dashboard"},
  {id:"usuarios",   icon:"👥", label:"Usuarios"},
  {id:"imagenes",   icon:"🖼",  label:"Imágenes"},
  {id:"personajes", icon:"🎭", label:"Personajes"},
  {id:"ingresos",   icon:"💰", label:"Ingresos"},
  {id:"apis",       icon:"⚡", label:"Costos y APIs"},
  {id:"proveedores",icon:"🏦", label:"Proveedores"},
  {id:"retencion",  icon:"📈", label:"Retención"},
  {id:"funciones",  icon:"🎯", label:"Funciones"},
  {id:"referidos",  icon:"🤝", label:"Referidos"},
  {id:"demo",       icon:"🔄", label:"Conversión demo"},
  {id:"upgrades",   icon:"↕️", label:"Upgrades"},
  {id:"sistema",    icon:"🔧", label:"Salud sistema"},
  {id:"soporte",    icon:"💬", label:"Soporte"},
  {id:"alertas",    icon:"🔔", label:"Alertas"},
  {id:"notas",      icon:"📝", label:"Notas"},
]

function Badge({type, label}) {
  const m = {
    ok:{bg:GREEN_BG,color:GREEN,t:"Operacional"}, pagado:{bg:GREEN_BG,color:GREEN,t:"Pagado"},
    gratuito:{bg:BLUE_BG,color:BLUE,t:"Gratuito"}, warning:{bg:ORANGE_BG,color:ORANGE,t:"Atención"},
    en_curso:{bg:ORANGE_BG,color:ORANGE,t:"En curso"}, pendiente:{bg:ORANGE_BG,color:ORANGE,t:"Pendiente"},
    resuelto:{bg:GREEN_BG,color:GREEN,t:"Resuelto"}, en_proceso:{bg:BLUE_BG,color:BLUE,t:"En proceso"},
    active:{bg:GREEN_BG,color:GREEN,t:"Activo"}, paused:{bg:ORANGE_BG,color:ORANGE,t:"Pausado"},
    alta:{bg:RED_BG,color:RED,t:"Alta"}, media:{bg:ORANGE_BG,color:ORANGE,t:"Media"}, baja:{bg:GREEN_BG,color:GREEN,t:"Baja"},
  }
  const c = m[type]||m.ok
  return <span style={{fontSize:10,fontWeight:700,background:c.bg,color:c.color,borderRadius:20,padding:"2px 9px",fontFamily:B}}>{label||c.t}</span>
}

function KPI({label,value,sub,trend,color=V}) {
  const up = parseFloat(trend) > 0
  return (
    <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem",borderTop:`3px solid ${color}`}}>
      <div style={{fontSize:11,color:MUTED,fontFamily:B,marginBottom:4}}>{label}</div>
      <div style={{fontFamily:H,fontSize:26,fontWeight:800,color:TEXT,letterSpacing:"-.02em",marginBottom:3}}>{value}</div>
      {sub && <div style={{fontSize:11,color:MUTED,fontFamily:B}}>{sub}</div>}
      {trend !== undefined && <div style={{fontSize:11,color:up?GREEN:RED,fontWeight:600,marginTop:3,fontFamily:B}}>{up?"↑":"↓"} {Math.abs(trend)}% vs mes anterior</div>}
    </div>
  )
}

function Bar({value,max,color=V}) {
  return <div style={{height:5,background:BORDER,borderRadius:3,overflow:"hidden",marginTop:4}}><div style={{height:"100%",width:`${Math.min((value/max)*100,100)}%`,background:color,borderRadius:3,transition:"width .4s"}}/></div>
}

function TH({children}) { return <div style={{fontSize:10,fontWeight:700,color:"rgba(255,255,255,.45)",textTransform:"uppercase",letterSpacing:".08em",fontFamily:B}}>{children}</div> }
function TD({children,bold,color}) { return <div style={{fontSize:12,fontFamily:B,fontWeight:bold?700:400,color:color||TEXT}}>{children}</div> }

function SectionTitle({icon,title,sub}) {
  return (
    <div style={{marginBottom:"1.5rem",paddingBottom:"1rem",borderBottom:`1px solid ${BORDER}`}}>
      <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:3}}>
        <span style={{fontSize:22}}>{icon}</span>
        <h2 style={{fontFamily:H,fontSize:22,fontWeight:800,color:TEXT,margin:0,letterSpacing:"-.02em"}}>{title}</h2>
      </div>
      {sub && <p style={{fontSize:13,color:MUTED,margin:0,fontFamily:B,marginLeft:32}}>{sub}</p>}
    </div>
  )
}

// SECTIONS
function Dashboard() {
  const d = DATA.overview
  const chg = pchg(d.ingresos_mes, d.ingresos_anterior)
  return (
    <div>
      <SectionTitle icon="📊" title="Dashboard" sub="Vista general del negocio en tiempo real · Mayo 2025"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Ingresos del mes" value={fmt(d.ingresos_mes)} trend={chg} color={GREEN}/>
        <KPI label="Usuarios activos" value={fmtn(d.usuarios_activos)} sub={`+${d.usuarios_nuevos} nuevos este mes`} color={V}/>
        <KPI label="Costo total APIs" value={fmt(d.costo_apis)} sub="Todas las APIs y servicios" color={ORANGE}/>
        <KPI label="Margen neto" value={fmt(d.margen)} sub={`${((d.margen/d.ingresos_mes)*100).toFixed(1)}% del ingreso`} color={GREEN}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:14}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,letterSpacing:".1em",color:MUTED,textTransform:"uppercase",marginBottom:"1rem",fontFamily:B}}>Usuarios por plan</div>
          {[{plan:"Starter",n:52,precio:47,color:"#C4B5FD"},{plan:"Growth",n:24,precio:87,color:V},{plan:"Agency",n:11,precio:147,color:"#4C1D95"}].map((p,i)=>(
            <div key={i} style={{marginBottom:".85rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                <span style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{p.plan} · {p.n} usuarios</span>
                <span style={{fontSize:12,fontWeight:700,color:GREEN,fontFamily:H}}>{fmt(p.n*p.precio)}</span>
              </div>
              <Bar value={p.n} max={87} color={p.color}/>
            </div>
          ))}
        </div>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,letterSpacing:".1em",color:MUTED,textTransform:"uppercase",marginBottom:"1rem",fontFamily:B}}>Alertas activas ({DATA.alertas.length})</div>
          {DATA.alertas.map((a,i)=>(
            <div key={i} style={{display:"flex",gap:8,padding:".6rem 0",borderBottom:i<DATA.alertas.length-1?`1px solid ${BORDER}`:"none",alignItems:"flex-start"}}>
              <span style={{fontSize:14,flexShrink:0}}>{a.tipo==="warning"?"⚠️":"ℹ️"}</span>
              <div>
                <div style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{a.titulo}</div>
                <div style={{fontSize:10,color:MUTED,fontFamily:B}}>{a.tiempo}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
        <KPI label="Imágenes normales este mes" value={fmtn(DATA.imagenes.normales_mes)} sub={`Costo DALL-E: ${fmt(DATA.imagenes.normales_mes*DATA.imagenes.costo_normal)}`} color={BLUE}/>
        <KPI label="Imágenes Animado 3D ⚡ este mes" value={fmtn(DATA.imagenes.pixar_mes)} sub={`2 créditos c/u · Costo: ${fmt(DATA.imagenes.pixar_mes*DATA.imagenes.costo_pixar)}`} color="#9333EA"/>
        <KPI label="Tasa de retención" value="94.2%" sub="5.8% churn · Objetivo >90%" color={GREEN}/>
      </div>
    </div>
  )
}

function Usuarios() {
  return (
    <div>
      <SectionTitle icon="👥" title="Usuarios" sub="Todos los usuarios con actividad, costo y estado"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Activos" value="87" color={GREEN}/><KPI label="Nuevos" value="14" color={V}/>
        <KPI label="Pausados" value="5" color={ORANGE}/><KPI label="Cancelaron" value="3" color={RED}/>
      </div>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"1.8fr 0.9fr 0.7fr 1fr 0.9fr 0.9fr 1fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["Usuario","Plan","Estado","Imágenes","Costo/mes","Ingresos","Último acceso"].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.usuarios.map((u,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"1.8fr 0.9fr 0.7fr 1fr 0.9fr 0.9fr 1fr",padding:".85rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <div><div style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{u.nombre}</div><div style={{fontSize:10,color:MUTED,fontFamily:B}}>{u.email}</div></div>
            <TD bold color={V}>{u.plan}</TD>
            <Badge type={u.estado}/>
            <div><div style={{fontSize:11,fontWeight:600,fontFamily:B}}>{u.imgs_usadas}/{u.imgs_total}</div><Bar value={u.imgs_usadas} max={u.imgs_total} color={u.imgs_usadas/u.imgs_total>.8?RED:V}/></div>
            <TD color={ORANGE}>{fmt(u.costo_mes)}</TD>
            <TD bold color={GREEN}>{fmt(u.ingresos)}</TD>
            <TD>{u.ultimo_acceso}</TD>
          </div>
        ))}
      </div>
    </div>
  )
}

function Imagenes() {
  const d = DATA.imagenes
  const cn = d.normales_mes*d.costo_normal, cp = d.pixar_mes*d.costo_pixar
  const paq_total = Object.values(d.paquetes).reduce((a,p)=>a+p.n*p.precio,0)
  return (
    <div>
      <SectionTitle icon="🖼" title="Imágenes" sub="Consumo de DALL-E, costos por tipo y paquetes vendidos"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Imágenes normales" value={fmtn(d.normales_mes)} sub={`Costo: ${fmt(cn)}`} color={BLUE}/>
        <KPI label="Imágenes Animado 3D ⚡" value={fmtn(d.pixar_mes)} sub={`2 créditos · Costo: ${fmt(cp)}`} color="#9333EA"/>
        <KPI label="Total DALL-E" value={fmt(cn+cp)} sub={`${fmtn(d.normales_mes+d.pixar_mes)} imágenes`} color={ORANGE}/>
        <KPI label="Paquetes extra" value={fmt(paq_total)} sub="Ingreso adicional" color={GREEN}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1rem",fontFamily:B}}>Costo por tipo de imagen</div>
          {[{label:"Imágenes normales",n:d.normales_mes,cu:d.costo_normal,total:cn,color:BLUE},{label:"Imágenes Animado 3D ⚡",n:d.pixar_mes,cu:d.costo_pixar,total:cp,color:"#9333EA"}].map((r,i)=>(
            <div key={i} style={{background:i?V_SOFT:BLUE_BG,borderRadius:10,padding:".85rem 1rem",marginBottom:8}}>
              <div style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B,marginBottom:4}}>{r.label}</div>
              <div style={{display:"flex",gap:"1.5rem"}}>
                <div><div style={{fontSize:10,color:MUTED,fontFamily:B}}>Cantidad</div><div style={{fontFamily:H,fontSize:16,fontWeight:800,color:r.color}}>{fmtn(r.n)}</div></div>
                <div><div style={{fontSize:10,color:MUTED,fontFamily:B}}>× Costo unit.</div><div style={{fontFamily:H,fontSize:16,fontWeight:800,color:r.color}}>{fmt(r.cu)}</div></div>
                <div><div style={{fontSize:10,color:MUTED,fontFamily:B}}>= Total</div><div style={{fontFamily:H,fontSize:16,fontWeight:800,color:r.color}}>{fmt(r.total)}</div></div>
              </div>
            </div>
          ))}
        </div>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1rem",fontFamily:B}}>Paquetes extra vendidos</div>
          {Object.entries(d.paquetes).map(([key,p],i)=>(
            <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:".65rem 0",borderBottom:i<2?`1px solid ${BORDER}`:"none"}}>
              <div><div style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{key==="mini"?"Mini (15 imgs)":key==="standard"?"Standard (40 imgs)":"Pro (100 imgs)"}</div><div style={{fontSize:11,color:MUTED,fontFamily:B}}>{p.n} vendidos × {fmt(p.precio)}</div></div>
              <div style={{fontFamily:H,fontSize:16,fontWeight:800,color:GREEN}}>{fmt(p.n*p.precio)}</div>
            </div>
          ))}
          <div style={{borderTop:`2px solid ${BORDER}`,marginTop:6,paddingTop:8,display:"flex",justifyContent:"space-between"}}>
            <span style={{fontSize:12,fontWeight:700,fontFamily:B}}>Total paquetes imágenes</span>
            <span style={{fontFamily:H,fontSize:16,fontWeight:800,color:GREEN}}>{fmt(paq_total)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

function Personajes() {
  const d = DATA.personajes
  const paq_total = Object.values(d.paquetes).reduce((a,p)=>a+p.n*p.precio,0)
  return (
    <div>
      <SectionTitle icon="🎭" title="Personajes" sub="Personajes Animado 3D creados, paquetes vendidos y próximos vencimientos"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Total creados" value={fmtn(d.total)} color="#9333EA"/>
        <KPI label="Creados este mes" value={fmtn(d.mes)} color={V}/>
        <KPI label="Costo total creación" value={fmt(d.total*d.costo_unit)} sub={`~${fmt(d.costo_unit)} por personaje`} color={ORANGE}/>
        <KPI label="Packs por vencer 30d" value={d.packs_vencer} sub="Enviar recordatorio" color={RED}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1rem",fontFamily:B}}>Paquetes vendidos</div>
          {[{key:"single",label:"1 personaje — $9",vence:"Sin vencimiento"},{key:"pack3",label:"Pack 3 — $19",vence:"Vence 6 meses"},{key:"pack5",label:"Pack 5 — $29",vence:"Vence 6 meses"}].map((item,i)=>{
            const p = d.paquetes[item.key]
            return (
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:".65rem 0",borderBottom:i<2?`1px solid ${BORDER}`:"none"}}>
                <div><div style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{item.label}</div><div style={{fontSize:10,color:MUTED,fontFamily:B}}>{p.n} vendidos · {item.vence}</div></div>
                <div style={{fontFamily:H,fontSize:16,fontWeight:800,color:GREEN}}>{fmt(p.n*p.precio)}</div>
              </div>
            )
          })}
          <div style={{borderTop:`2px solid ${BORDER}`,marginTop:6,paddingTop:8,display:"flex",justifyContent:"space-between"}}>
            <span style={{fontSize:12,fontWeight:700,fontFamily:B}}>Total paquetes personajes</span>
            <span style={{fontFamily:H,fontSize:16,fontWeight:800,color:GREEN}}>{fmt(paq_total)}</span>
          </div>
        </div>
        <div style={{background:RED_BG,border:`1px solid #FECACA`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:RED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:".75rem",fontFamily:B}}>🔔 Packs por vencer en 30 días</div>
          <div style={{fontFamily:H,fontSize:42,fontWeight:800,color:RED,marginBottom:4}}>{d.packs_vencer}</div>
          <div style={{fontSize:12,color:"#991B1B",fontFamily:B,lineHeight:1.65}}>usuarios tienen paquetes de personajes que vencen pronto. KORIVA debería enviarles un correo de recordatorio automático. Verificar que el sistema de correos está activo.</div>
          <div style={{marginTop:"1rem",background:"rgba(220,38,38,.1)",borderRadius:8,padding:".75rem",fontSize:11,color:RED,fontFamily:B}}>⚡ Los personajes son Animado 3D — cada creación te cuesta {fmt(d.costo_unit)}. Si no los usan antes de que venza el pack, el usuario pierde créditos ya pagados.</div>
        </div>
      </div>
    </div>
  )
}

function Ingresos() {
  const d = DATA.ingresos
  const total_subs = Object.values(d.subs).reduce((a,p)=>a+p.n*p.precio,0)
  const total_imgs = Object.values(d.packs_img).reduce((a,p)=>a+p.n*p.precio,0)
  const total_chars = Object.values(d.packs_char).reduce((a,p)=>a+p.n*p.precio,0)
  const total = total_subs+total_imgs+total_chars
  return (
    <div>
      <SectionTitle icon="💰" title="Ingresos" sub="Desglose completo de ingresos por suscripciones y paquetes"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Total del mes" value={fmt(total)} trend={pchg(total,3890)} color={GREEN}/>
        <KPI label="Suscripciones" value={fmt(total_subs)} sub="87 usuarios activos" color={V}/>
        <KPI label="Paquetes imágenes" value={fmt(total_imgs)} color={BLUE}/>
        <KPI label="Paquetes personajes" value={fmt(total_chars)} color="#9333EA"/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden"}}>
          <div style={{padding:".85rem 1.1rem",background:DARK}}><div style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,.45)",textTransform:"uppercase",letterSpacing:".1em",fontFamily:B}}>Por plan</div></div>
          {Object.entries(d.subs).map(([plan,data],i)=>(
            <div key={i} style={{padding:".85rem 1.1rem",borderBottom:`1px solid ${BORDER}`,display:"flex",justifyContent:"space-between",alignItems:"center",background:i%2?OFF:WHITE}}>
              <div><div style={{fontFamily:H,fontSize:13,fontWeight:700,color:TEXT,textTransform:"capitalize"}}>{plan}</div><div style={{fontSize:11,color:MUTED,fontFamily:B}}>{data.n} usuarios × {fmt(data.precio)}</div></div>
              <div style={{fontFamily:H,fontSize:18,fontWeight:800,color:GREEN}}>{fmt(data.n*data.precio)}</div>
            </div>
          ))}
          <div style={{padding:".85rem 1.1rem",background:DARK,display:"flex",justifyContent:"space-between"}}>
            <span style={{fontFamily:H,fontSize:13,fontWeight:800,color:WHITE}}>Total suscripciones</span>
            <span style={{fontFamily:H,fontSize:18,fontWeight:800,color:"#A78BFA"}}>{fmt(total_subs)}</span>
          </div>
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1rem 1.1rem",flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:".75rem",fontFamily:B}}>Paquetes adicionales</div>
            {[{label:"Imágenes",total:total_imgs,color:BLUE},{label:"Personajes",total:total_chars,color:"#9333EA"}].map((p,i)=>(
              <div key={i} style={{display:"flex",justifyContent:"space-between",padding:".5rem 0",borderBottom:i<1?`1px solid ${BORDER}`:"none"}}>
                <span style={{fontSize:12,fontFamily:B,color:TEXT}}>{p.label}</span>
                <span style={{fontFamily:H,fontSize:15,fontWeight:800,color:p.color}}>{fmt(p.total)}</span>
              </div>
            ))}
          </div>
          <div style={{background:DARK,borderRadius:12,padding:"1.25rem 1.1rem"}}>
            <div style={{fontSize:11,color:"rgba(255,255,255,.4)",marginBottom:4,fontFamily:B}}>Ingreso total del mes</div>
            <div style={{fontFamily:H,fontSize:36,fontWeight:800,color:WHITE}}>{fmt(total)}</div>
            <div style={{fontSize:11,color:"rgba(255,255,255,.4)",marginTop:4,fontFamily:B}}>↑ {pchg(total,3890)}% vs mes anterior ($3,890.00)</div>
          </div>
        </div>
      </div>
    </div>
  )
}

function APIs() {
  const total = DATA.apis.reduce((a,r)=>a+r.total,0)
  const ing = DATA.overview.ingresos_mes
  const margen = ing - total
  const mpct = ((margen/ing)*100).toFixed(1)
  return (
    <div>
      <SectionTitle icon="⚡" title="Costos y APIs" sub="Fórmula detallada: cantidad × costo unitario = total por servicio"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Costo total servicios" value={fmt(total)} color={ORANGE}/>
        <KPI label="Ingreso total" value={fmt(ing)} color={GREEN}/>
        <KPI label="Margen neto" value={fmt(margen)} sub={`${mpct}% · Objetivo mínimo 80%`} color={parseFloat(mpct)>80?GREEN:RED}/>
      </div>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden",marginBottom:12}}>
        <div style={{display:"grid",gridTemplateColumns:"2.5fr 0.8fr 1fr 0.8fr 1fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["Concepto","Servicio","Cantidad × Unidad","Costo unit.","= Total"].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.apis.map((r,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"2.5fr 0.8fr 1fr 0.8fr 1fr",padding:".8rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <TD>{r.nombre}</TD>
            <div style={{fontSize:10,color:MUTED,fontFamily:B,fontWeight:600}}>{r.servicio}</div>
            <TD>{typeof r.cantidad==="number"?fmtn(r.cantidad):r.cantidad} {r.unidad}</TD>
            <TD color={MUTED}>{r.costo_unit===0?"Gratuito":fmt(r.costo_unit)}</TD>
            <div style={{fontFamily:H,fontSize:13,fontWeight:800,color:r.total>100?RED:r.total>30?ORANGE:TEXT}}>{fmt(r.total)}</div>
          </div>
        ))}
        <div style={{display:"grid",gridTemplateColumns:"2.5fr 0.8fr 1fr 0.8fr 1fr",padding:".85rem 1rem",background:DARK,gap:8}}>
          <div style={{fontSize:12,fontWeight:700,color:WHITE,fontFamily:H,gridColumn:"1/5"}}>TOTAL COSTOS DEL MES</div>
          <div style={{fontFamily:H,fontSize:16,fontWeight:800,color:"#A78BFA"}}>{fmt(total)}</div>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12}}>
        <div style={{background:GREEN_BG,border:`1px solid #A7F3D0`,borderRadius:10,padding:"1rem"}}>
          <div style={{fontSize:11,color:GREEN,fontWeight:700,fontFamily:B,marginBottom:4}}>✓ Margen saludable</div>
          <div style={{fontFamily:H,fontSize:28,fontWeight:800,color:GREEN}}>{mpct}%</div>
          <div style={{fontSize:11,color:GREEN,fontFamily:B}}>Objetivo mínimo: 80%</div>
        </div>
        <div style={{background:ORANGE_BG,border:`1px solid #FDE68A`,borderRadius:10,padding:"1rem"}}>
          <div style={{fontSize:11,color:ORANGE,fontWeight:700,fontFamily:B,marginBottom:4}}>⚠️ Mayor costo</div>
          <div style={{fontFamily:H,fontSize:15,fontWeight:800,color:ORANGE}}>Stripe Fees</div>
          <div style={{fontSize:11,color:ORANGE,fontFamily:B}}>{fmt(145.29)} · {((145.29/total)*100).toFixed(0)}% del costo total</div>
        </div>
        <div style={{background:BLUE_BG,border:`1px solid #BFDBFE`,borderRadius:10,padding:"1rem"}}>
          <div style={{fontSize:11,color:BLUE,fontWeight:700,fontFamily:B,marginBottom:4}}>📊 Costo por usuario</div>
          <div style={{fontFamily:H,fontSize:28,fontWeight:800,color:BLUE}}>{fmt(total/87)}</div>
          <div style={{fontSize:11,color:BLUE,fontFamily:B}}>Promedio por usuario activo</div>
        </div>
      </div>
    </div>
  )
}

function Proveedores() {
  const total = DATA.proveedores.reduce((a,p)=>a+p.monto,0)
  return (
    <div>
      <SectionTitle icon="🏦" title="Proveedores" sub="Estado de pagos y fechas de renovación de todos los servicios"/>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 0.8fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["Proveedor","Tipo","Último pago","Próximo pago","Monto estimado","Estado"].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.proveedores.map((p,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 0.8fr",padding:".9rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <div><div style={{fontSize:12,fontWeight:700,color:TEXT,fontFamily:H}}>{p.nombre}</div></div>
            <TD color={MUTED}>{p.tipo}</TD>
            <TD>{p.ultimo}</TD>
            <TD>{p.proximo}</TD>
            <div style={{fontFamily:H,fontSize:13,fontWeight:800,color:p.monto===0?GREEN:ORANGE}}>{p.monto===0?"Gratuito":fmt(p.monto)}</div>
            <Badge type={p.estado}/>
          </div>
        ))}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 0.8fr",padding:".85rem 1rem",background:DARK,gap:8}}>
          <div style={{fontSize:12,fontWeight:700,color:WHITE,fontFamily:H,gridColumn:"1/5"}}>TOTAL ESTIMADO ESTE MES</div>
          <div style={{fontFamily:H,fontSize:16,fontWeight:800,color:"#A78BFA"}}>{fmt(total)}</div>
          <div/>
        </div>
      </div>
    </div>
  )
}

function Retencion() {
  const d = DATA.retencion
  return (
    <div>
      <SectionTitle icon="📈" title="Retención y comportamiento" sub="Qué tan bien está reteniendo KORIVA a sus usuarios"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Tasa de renovación" value={`${d.renovacion}%`} sub="Objetivo: >90%" color={GREEN}/>
        <KPI label="Churn rate" value={`${d.churn}%`} color={d.churn<10?GREEN:RED}/>
        <KPI label="Activos últimos 7 días" value={d.activos_7d} sub="de 87 totales" color={V}/>
        <KPI label="Inactivos >14 días" value={d.inactivos_14d} sub="Riesgo de cancelación" color={RED}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1rem",fontFamily:B}}>Crecimiento de usuarios por mes</div>
          <div style={{display:"flex",alignItems:"flex-end",gap:10,height:120,marginBottom:10}}>
            {d.meses.map((mes,i)=>{
              const h = (d.usuarios[i]/87)*100
              return (
                <div key={i} style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                  <div style={{fontSize:10,color:V,fontFamily:B,fontWeight:700}}>{d.usuarios[i]}</div>
                  <div style={{width:"100%",height:`${h}%`,background:i===d.meses.length-1?V:V_MID,borderRadius:"4px 4px 0 0"}}/>
                  <div style={{fontSize:10,color:MUTED,fontFamily:B}}>{mes}</div>
                </div>
              )
            })}
          </div>
        </div>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.1rem 1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1rem",fontFamily:B}}>Actividad de usuarios</div>
          {[
            {label:"Activos hoy",n:34,max:87,color:GREEN},
            {label:"Activos esta semana",n:71,max:87,color:V},
            {label:"Inactivos 7-14 días",n:d.activos_7d-d.inactivos_14d-34,max:87,color:ORANGE},
            {label:"Inactivos >14 días",n:d.inactivos_14d,max:87,color:RED},
          ].map((item,i)=>(
            <div key={i} style={{marginBottom:".85rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                <span style={{fontSize:11,color:TEXT,fontFamily:B}}>{item.label}</span>
                <span style={{fontSize:11,fontWeight:700,color:item.color,fontFamily:B}}>{item.n}</span>
              </div>
              <Bar value={item.n} max={item.max} color={item.color}/>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function Funciones() {
  return (
    <div>
      <SectionTitle icon="🎯" title="Funciones más usadas" sub="Qué están usando los usuarios — dónde invertir en mejorar el producto"/>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.25rem"}}>
        {DATA.funciones.map((f,i)=>(
          <div key={i} style={{marginBottom:"1rem"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
              <span style={{fontSize:12,fontWeight:600,color:TEXT,fontFamily:B}}>{f.nombre}</span>
              <div style={{display:"flex",gap:12}}>
                <span style={{fontSize:11,color:MUTED,fontFamily:B}}>{fmtn(f.usos)} usos</span>
                <span style={{fontSize:11,fontWeight:700,color:f.color,fontFamily:B,minWidth:36,textAlign:"right"}}>{f.pct}%</span>
              </div>
            </div>
            <Bar value={f.pct} max={100} color={f.color}/>
          </div>
        ))}
      </div>
    </div>
  )
}

function Referidos() {
  const total_ref = DATA.referidos.reduce((a,r)=>a+r.referidos,0)
  const total_conv = DATA.referidos.reduce((a,r)=>a+r.convertidos,0)
  const total_ing = DATA.referidos.reduce((a,r)=>a+r.ingresos,0)
  const total_cred = DATA.referidos.reduce((a,r)=>a+r.credito,0)
  return (
    <div>
      <SectionTitle icon="🤝" title="Referidos" sub="Quién trae más usuarios y cuánto genera el programa"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Referidos enviados" value={total_ref} color={V}/>
        <KPI label="Convertidos" value={total_conv} sub={`${((total_conv/total_ref)*100).toFixed(0)}% conversión`} color={GREEN}/>
        <KPI label="Ingresos generados" value={fmt(total_ing)} color={GREEN}/>
        <KPI label="Créditos entregados" value={fmt(total_cred)} sub="Costo del programa" color={ORANGE}/>
      </div>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden",marginBottom:12}}>
        <div style={{display:"grid",gridTemplateColumns:"1.5fr 0.8fr 0.8fr 1fr 1fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["Usuario","Referidos","Convertidos","Ingresos generados","Crédito ganado"].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.referidos.map((r,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"1.5fr 0.8fr 0.8fr 1fr 1fr",padding:".85rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <TD bold>{r.usuario}</TD>
            <TD>{r.referidos}</TD>
            <TD bold color={GREEN}>{r.convertidos}</TD>
            <div style={{fontFamily:H,fontSize:13,fontWeight:800,color:GREEN}}>{fmt(r.ingresos)}</div>
            <div style={{fontFamily:H,fontSize:13,fontWeight:800,color:ORANGE}}>{fmt(r.credito)}</div>
          </div>
        ))}
      </div>
      <div style={{background:GREEN_BG,border:`1px solid #A7F3D0`,borderRadius:10,padding:"1rem 1.25rem"}}>
        <div style={{fontSize:12,color:GREEN,fontFamily:B,fontWeight:600}}>
          ROI del programa: por cada {fmt(total_cred)} en créditos entregados generaste {fmt(total_ing)} en ingresos nuevos. {(total_ing/total_cred).toFixed(1)}x retorno.
        </div>
      </div>
    </div>
  )
}

function Demo() {
  const d = DATA.demo
  return (
    <div>
      <SectionTitle icon="🔄" title="Conversión de la demo" sub="Cuántas personas que ven la landing terminan comprando"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Visitas landing" value={fmtn(d.visitas)} color={BLUE}/>
        <KPI label="Demos iniciadas" value={fmtn(d.demos)} sub={`${d.tasa_demo}% de las visitas`} color={V}/>
        <KPI label="Compraron un plan" value={fmtn(d.compras)} sub={`${d.tasa_total}% de las visitas`} color={GREEN}/>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,padding:"1.25rem"}}>
          <div style={{fontSize:11,fontWeight:700,color:MUTED,textTransform:"uppercase",letterSpacing:".1em",marginBottom:"1.25rem",fontFamily:B}}>Embudo de conversión</div>
          {[{label:"Visitas landing",n:d.visitas,pct:100,color:BLUE},{label:"Demos iniciadas",n:d.demos,pct:d.tasa_demo,color:V},{label:"Compraron",n:d.compras,pct:d.tasa_total,color:GREEN}].map((item,i)=>(
            <div key={i} style={{marginBottom:"1rem"}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:4}}>
                <span style={{fontSize:12,fontFamily:B,color:TEXT}}>{item.label}</span>
                <span style={{fontSize:12,fontWeight:700,color:item.color,fontFamily:B}}>{fmtn(item.n)} ({item.pct}%)</span>
              </div>
              <Bar value={item.pct} max={100} color={item.color}/>
            </div>
          ))}
        </div>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          {[{label:"Landing → Demo",val:d.tasa_demo,color:BLUE,bg:BLUE_BG},{label:"Demo → Compra",val:d.tasa_compra,color:V,bg:V_SOFT},{label:"Landing → Compra (total)",val:d.tasa_total,color:GREEN,bg:GREEN_BG}].map((item,i)=>(
            <div key={i} style={{background:item.bg,borderRadius:10,padding:"1rem 1.25rem",flex:1}}>
              <div style={{fontSize:11,color:item.color,fontFamily:B,marginBottom:3}}>{item.label}</div>
              <div style={{fontFamily:H,fontSize:30,fontWeight:800,color:item.color}}>{item.val}%</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function Upgrades() {
  return (
    <div>
      <SectionTitle icon="↕️" title="Upgrades y downgrades" sub="Movimientos de plan este mes"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Upgrades este mes" value="2" sub="Subieron de plan" color={GREEN}/>
        <KPI label="Downgrades este mes" value="1" sub="Bajaron de plan" color={ORANGE}/>
        <KPI label="Impacto neto" value={fmt(87)} sub="Ingreso adicional por cambios" color={GREEN}/>
      </div>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"1.5fr 1fr 1fr 1fr 0.8fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["Usuario","Plan anterior","Plan nuevo","Fecha","Tipo"].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.upgrades.map((u,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"1.5fr 1fr 1fr 1fr 0.8fr",padding:".85rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <TD bold>{u.usuario}</TD>
            <TD color={MUTED}>{u.de}</TD>
            <TD bold color={u.tipo==="up"?GREEN:ORANGE}>{u.tipo==="up"?"↑":""} {u.a}</TD>
            <TD>{u.fecha}</TD>
            <Badge type={u.tipo==="up"?"pagado":"warning"} label={u.tipo==="up"?"Upgrade":"Downgrade"}/>
          </div>
        ))}
      </div>
    </div>
  )
}

function Sistema() {
  return (
    <div>
      <SectionTitle icon="🔧" title="Salud del sistema" sub="Estado en tiempo real de todos los servicios"/>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        {DATA.sistema.map((s,i)=>(
          <div key={i} style={{background:WHITE,border:`1.5px solid ${s.estado==="ok"?GREEN:ORANGE}`,borderRadius:12,padding:"1rem 1.25rem",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div>
              <div style={{fontFamily:H,fontSize:14,fontWeight:700,color:TEXT,marginBottom:4}}>{s.nombre}</div>
              <div style={{display:"flex",gap:"1.5rem"}}>
                <span style={{fontSize:11,color:MUTED,fontFamily:B}}>Latencia: <strong>{s.latencia}</strong></span>
                <span style={{fontSize:11,color:MUTED,fontFamily:B}}>Uptime: <strong>{s.uptime}</strong></span>
              </div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:10,height:10,borderRadius:"50%",background:s.estado==="ok"?GREEN:ORANGE}}/>
              <Badge type={s.estado} label={s.estado==="ok"?"Operacional":"Atención"}/>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function Soporte() {
  return (
    <div>
      <SectionTitle icon="💬" title="Soporte" sub="Tickets reportados por usuarios — seguimiento y resolución"/>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:14}}>
        <KPI label="Tickets abiertos" value="2" color={ORANGE}/>
        <KPI label="Resueltos este mes" value="1" color={GREEN}/>
        <KPI label="Prioridad alta" value="2" sub="Requieren atención inmediata" color={RED}/>
      </div>
      <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:12,overflow:"hidden"}}>
        <div style={{display:"grid",gridTemplateColumns:"0.5fr 1.5fr 2fr 0.8fr 0.9fr 0.8fr 0.7fr",padding:".75rem 1rem",background:DARK,gap:8}}>
          {["ID","Usuario","Asunto","Fecha","Estado","Prioridad",""].map((h,i)=><TH key={i}>{h}</TH>)}
        </div>
        {DATA.soporte.map((t,i)=>(
          <div key={i} style={{display:"grid",gridTemplateColumns:"0.5fr 1.5fr 2fr 0.8fr 0.9fr 0.8fr 0.7fr",padding:".85rem 1rem",borderBottom:`1px solid ${BORDER}`,background:i%2?OFF:WHITE,gap:8,alignItems:"center"}}>
            <TD color={MUTED}>{t.id}</TD>
            <TD bold>{t.usuario}</TD>
            <TD>{t.asunto}</TD>
            <TD>{t.fecha}</TD>
            <Badge type={t.estado}/>
            <Badge type={t.prioridad}/>
            <span style={{fontSize:11,color:V,cursor:"pointer",fontFamily:B}}>Ver →</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function Alertas() {
  return (
    <div>
      <SectionTitle icon="🔔" title="Alertas" sub="Todo lo que requiere tu atención — ordenado por urgencia"/>
      <div style={{display:"flex",flexDirection:"column",gap:12}}>
        {DATA.alertas.map((a,i)=>(
          <div key={i} style={{background:WHITE,border:`1.5px solid ${a.tipo==="warning"?ORANGE:BLUE}`,borderRadius:12,padding:"1.1rem 1.25rem",display:"flex",gap:"1rem",alignItems:"flex-start"}}>
            <div style={{fontSize:24,flexShrink:0}}>{a.tipo==="warning"?"⚠️":"ℹ️"}</div>
            <div style={{flex:1}}>
              <div style={{fontFamily:H,fontSize:14,fontWeight:700,color:TEXT,marginBottom:3}}>{a.titulo}</div>
              <div style={{fontSize:12,color:MUTED,fontFamily:B,marginBottom:3}}>{a.desc}</div>
              <div style={{fontSize:11,color:MUTED,fontFamily:B}}>{a.tiempo}</div>
            </div>
            <button style={{padding:"7px 16px",background:a.tipo==="warning"?ORANGE:BLUE,color:WHITE,border:"none",borderRadius:7,fontFamily:B,fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0}}>Resolver</button>
          </div>
        ))}
      </div>
    </div>
  )
}

function Notas({notas, setNotas}) {
  const [nueva, setNueva] = useState("")
  function agregar() {
    if (!nueva.trim()) return
    const hoy = new Date().toLocaleDateString("es-MX",{day:"numeric",month:"short",year:"numeric"})
    setNotas(prev=>[{fecha:hoy,texto:nueva},...prev])
    setNueva("")
  }
  return (
    <div>
      <SectionTitle icon="📝" title="Notas del negocio" sub="Tu bloc de notas privado — decisiones, ideas y pendientes"/>
      <textarea value={nueva} onChange={e=>setNueva(e.target.value)} placeholder="Escribe una nota nueva..."
        style={{width:"100%",border:`1.5px solid ${BORDER}`,borderRadius:10,padding:"12px 14px",fontFamily:B,fontSize:13,color:TEXT,outline:"none",resize:"vertical",minHeight:80,marginBottom:8,boxSizing:"border-box"}}/>
      <button onClick={agregar} style={{padding:"9px 20px",background:V,color:WHITE,border:"none",borderRadius:8,fontFamily:H,fontSize:13,fontWeight:700,cursor:"pointer",marginBottom:"1.5rem"}}>
        Guardar nota →
      </button>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {notas.map((n,i)=>(
          <div key={i} style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:10,padding:"1rem 1.25rem"}}>
            <div style={{fontSize:10,color:MUTED,fontFamily:B,marginBottom:5}}>{n.fecha}</div>
            <div style={{fontSize:13,color:TEXT,fontFamily:B,lineHeight:1.65}}>{n.texto}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function KorivaAdmin() {
  const [view, setView] = useState("dashboard")
  const [notas, setNotas] = useState(DATA.notas_init)

  const VIEWS = {
    dashboard:<Dashboard/>, usuarios:<Usuarios/>, imagenes:<Imagenes/>,
    personajes:<Personajes/>, ingresos:<Ingresos/>, apis:<APIs/>,
    proveedores:<Proveedores/>, retencion:<Retencion/>, funciones:<Funciones/>,
    referidos:<Referidos/>, demo:<Demo/>, upgrades:<Upgrades/>,
    sistema:<Sistema/>, soporte:<Soporte/>, alertas:<Alertas/>,
    notas:<Notas notas={notas} setNotas={setNotas}/>,
  }

  return (
    <div style={{minHeight:"100vh",background:OFF,fontFamily:B,color:TEXT,display:"flex"}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=Manrope:wght@300;400;500;600&display=swap'); *{box-sizing:border-box}`}</style>

      {/* SIDEBAR */}
      <div style={{width:210,background:DARK,minHeight:"100vh",position:"fixed",top:0,left:0,display:"flex",flexDirection:"column",zIndex:10}}>
        <div style={{padding:"1.25rem 1.1rem 1rem",borderBottom:"1px solid rgba(255,255,255,.06)"}}>
          <div style={{fontFamily:H,fontSize:14,fontWeight:800,color:WHITE,letterSpacing:"-.02em"}}>
            KORIVA <span style={{color:"#A78BFA"}}>Admin</span>
          </div>
          <div style={{fontSize:10,color:"rgba(255,255,255,.25)",fontFamily:B,marginTop:2}}>Solo uso interno · admin.korivalab.com</div>
        </div>
        <div style={{flex:1,overflowY:"auto",padding:".6rem .6rem"}}>
          {NAV.map(item=>{
            const isActive = view===item.id
            const isAlert = item.id==="alertas"
            return (
              <button key={item.id} onClick={()=>setView(item.id)}
                style={{width:"100%",display:"flex",alignItems:"center",gap:8,padding:".55rem .75rem",borderRadius:8,border:"none",background:isActive?"rgba(124,58,237,.25)":"transparent",color:isActive?"#C4B5FD":"rgba(255,255,255,.4)",cursor:"pointer",fontFamily:B,fontSize:12,fontWeight:isActive?600:400,marginBottom:1,textAlign:"left",transition:"all .15s",position:"relative"}}>
                <span style={{fontSize:13}}>{item.icon}</span>
                {item.label}
                {isAlert&&DATA.alertas.length>0&&<span style={{marginLeft:"auto",background:RED,color:WHITE,borderRadius:"50%",width:16,height:16,display:"flex",alignItems:"center",justifyContent:"center",fontSize:9,fontWeight:700}}>{DATA.alertas.length}</span>}
                {isActive&&<div style={{position:"absolute",left:0,top:"20%",bottom:"20%",width:2.5,background:"#A78BFA",borderRadius:2}}/>}
              </button>
            )
          })}
        </div>
        <div style={{padding:"1rem 1.1rem",borderTop:"1px solid rgba(255,255,255,.06)"}}>
          <div style={{fontSize:10,color:"rgba(255,255,255,.2)",fontFamily:B}}>Mayo 2025 · v1.0</div>
        </div>
      </div>

      {/* MAIN */}
      <div style={{marginLeft:210,flex:1,padding:"2rem 2.25rem",maxWidth:"calc(100vw - 210px)"}}>
        {VIEWS[view]||<Dashboard/>}
      </div>
    </div>
  )
}
